import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { AuthCard } from "@/components/auth-card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { SetPasswordForm } from "@/features/staff/set-password/form";
import { m } from "@/lib/paraglide/messages.js";

// Better Auth checks the invitation's token, then redirects here with ?token=, or with
// ?error=INVALID_TOKEN when the link was used or has expired.
const SetPasswordSearch = z.object({
  token: z.string().min(1).optional().catch(undefined),
  error: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/staff/set-password")({
  validateSearch: SetPasswordSearch,
  component: SetPasswordPage,
});

function SetPasswordPage() {
  const { token, error } = Route.useSearch();
  const router = useRouter();
  return (
    <AuthCard title={m.staff_set_password_title()} area="staff">
      {token && !error ? (
        <SetPasswordForm
          token={token}
          onDone={() => router.navigate({ to: "/staff/login", search: { password: "set" } })}
        />
      ) : (
        <Alert variant="destructive">
          <AlertDescription>{m.staff_set_password_link_expired()}</AlertDescription>
        </Alert>
      )}
    </AuthCard>
  );
}
